/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Text } from '@tonic-one/react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isInUIC, setCookie } from '@Utils/common';
import { PRODUCT_NAME } from '@Utils/const';

function Provision() {
  const [text, setText] = useState(<></>);
  const [urlSearchParams] = useSearchParams();

  let _type = urlSearchParams.get('type');
  const cookieContent = {
    code: urlSearchParams.get('code'),
    state: urlSearchParams.get('state'),
    serviceType: urlSearchParams.get('service_type'),
    status: urlSearchParams.get('status'),
    error: urlSearchParams.get('error') || '',
  };

  //for gmail
  const _state = cookieContent.state;
  if (!_type) {
    if (_state === 'reauth' || _state === 'state-token') {
      _type = '21';
    } else if (
      _state === 'reauth-gmail-inline' ||
      _state === 'state-token-gmail-inline'
    ) {
      _type = '22';
    }
  }
  if (!_type) {
    //order is important, so we can get the correct type
    // some state may be prefix of another state
    // for example, 'azuread_graph_teams_chat' is prefix of 'azuread_graph_teams_chat_basic'
    // so we need to put 'azuread_graph_teams_chat' before 'azuread_graph_teams_chat_basic'
    // to make sure we get the correct type
    const stateArr = [
      'azuread_ews',
      'azuread_graph_ex',
      'office365_anomaly_management_api',
      'mitigation_api',
      'soc_graph_api',
      'soc_management_api',
      'azuread_sharepoint',
      'azuread_graph_sp', // new sharepoint provision first app
      'azuread_graph_basic_sp', // new sharepoint provision second app
      'azuread_graph_od', // new onedrive provision first app
      'azuread_graph_basic_od', // new onedrive provision second app
      'csom_onedrive_basic',
      'mip_check_license',
      'mip_decrypt_file',
      'mip_access_sensitivity_labels',
      'mip_csom_apply_label',
      'azuread_mail_flow_ex',
      'azuread_mail_inline_graph_api', // exchange inline provision second app
      'azuread_mail_flow_inline_ex', // exchange inline provision first app
      'microsoft_identity_protection_api',
      'azuread_graph_notification',
      'csom_sharepoint_admin',
      'csom_sharepoint',
      'azuread_graph_teams_chat',
      'azuread_graph_teams', // new teams provision first app
      'azuread_graph_basic_teams', // new teams provision second app
      'microsoft_audit_log',
    ];
    for (const v of stateArr) {
      if (_state && _state.indexOf(v) === 0) {
        _type = v;
        break;
      }
    }
  }

  const cookieName = 'provision_status_' + _type;
  setCookie(cookieName, JSON.stringify(cookieContent));

  useEffect(() => {
    if (urlSearchParams.get('error')) {
      setText(
        <>
          <Text>You denied {PRODUCT_NAME} access to your service.</Text>
          <Text>
            To grant access again, go back to the {PRODUCT_NAME} console.
          </Text>
        </>
      );
    } else {
      setText(
        <Text>
          Permission granted successfully. Go back to the {PRODUCT_NAME} console
          to continue with access grant process.
        </Text>
      );
    }
    const title = document.querySelector('head title');
    if (isInUIC() && title) {
      title.innerHTML = 'Trend Vision One&trade;';
    }
  }, []);
  return (
    <Box m="20px" fontSize="16px">
      {text}
    </Box>
  );
}

export default Provision;
